// ---------------------------------------------------------------------------------------
// AUTHOR : VINAYAKA D
// ---------------------------------------------------------------------------------------
// PAGE : WEB-REQUEST.SERVICE.TS
// ---------------------------------------------------------------------------------------
// COMMENT: THIS PAGE IS TO CREATE THE WEB SERVICES AND PROVIDERS
// ---------------------------------------------------------------------------------------
// LAST MODIFIED : 24/03/2020
// ---------------------------------------------------------------------------------------

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpRequest,
  HttpEventType,
  HttpEvent,
} from '@angular/common/http';
import { ErrorConstants } from 'src/constants/error-constants';
import { UrlConstants } from 'src/constants/url-constants';
import { map, tap, last } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';
import { Data } from '../helper/datastore';
import { rejects } from 'assert';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class WebRequestService {
  _errors: any = ErrorConstants.ERROR_MESSAGES;
  _urls: any = UrlConstants.ENDPOINTS;
  _commonHeader: any;
  _herderOption: any;
  _header: any;
  _imageherderOption: any;
  _imageHeader: any;
  _accessToken: any;
  custprofileId: any;
  enableNav: boolean;

  public progressSource = new BehaviorSubject<number>(0);
  isProfilePanelCollapse: boolean;
  isAestroPanelCollapse: boolean;
  isEduPanelCollapse: boolean;
  jobLocationCollapse: boolean;
  isAstroCollapse: boolean;
  isPartnerCollapse: boolean;
  isProfileSettingsCollapse: boolean;
  isHabbitCollapse: boolean;
  isGradeCollapse: boolean;
  counter: number = 0;
  positionA: number = 0;
  positionB: number = 0;
  profileDetails: any;

  readonly ROOT_URL;

    subject =  new BehaviorSubject<any>([]);

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private data: Data
  ) {
    this.ROOT_URL = this._urls.ADMIN_URL;

    // common hedder global request
    this._accessToken = this.cookieService.get('x-access-token');

    this.setToken();
  }

  sendData(value: any) {
    this.subject.next(value);
}
 trimStr(str) {
  return str.replace(/[^\d]/g, '');
}
// clearMessages() {
//     this.subject.next();
// }

getData(): Observable<any> {
    return this.subject.asObservable();
}
  setToken() {
    const cookieExists: boolean = this.cookieService.check('x-access-token');
    // //console.log(cookieExists);
    if (cookieExists) {
      this._accessToken = this.cookieService.get('x-access-token');

      this._commonHeader = 'bearer ' + this._accessToken;
      // //console.log(this._commonHeader);
      this._herderOption = new HttpHeaders({
        Authorization: this._commonHeader,
      });

      this._header = { headers: this._herderOption };

      this._commonHeader = 'bearer ' + this._accessToken;
      // //console.log(this._commonHeader);
      this._imageherderOption = new HttpHeaders({
        Authorization: this._commonHeader,
      });

      this._imageHeader = { headers: this._imageherderOption };
    } else {
      // //console.log('has access token' + this.data._accessToken);

      this._accessToken = this.data._accessToken;

      this._commonHeader = 'bearer' + this._accessToken;
      // //console.log(this._commonHeader);
      this._herderOption = new HttpHeaders({
        Authorization: this._commonHeader,
      });

      this._header = { headers: this._herderOption };

      this._commonHeader = 'bearer' + this._accessToken;
      // //console.log(this._commonHeader);
      this._imageherderOption = new HttpHeaders({
        Authorization: this._commonHeader,
      });

      this._imageHeader = { headers: this._imageherderOption };
      // alert(this.data._accessToken);
    }
  }

  async getAdminMasterData() {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.ADMIN_MASTER}`, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // Submit Assign Data
  async submitAssignedData(data, start, end) {
    this.setToken();
    data.startIndexID = start;
    data.endIndexID = end;

    console.log(data);

    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.SUBMIT_ASSIGN}`, data, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

   // Submit UnAssign Data

   async submitUnAssignedData(data, start, end) {
    this.setToken();
    data.startIndexID = start;
    data.endIndexID = end;
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.SUBMIT_UNASSIGN}`, data, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // Reassing the ticket
  async submitReassignData(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.REASSIGN_TICKET}`, data, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //MASTER PAGE  
  async submitMasterData(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.ADD_TO_MASTER_DATA}`, data, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  
  // ASSIGN_OWNER

  async submitOwneredData(data) {
    this.setToken();
    // data.startIndexID = start;
    // data.endIndexID = end;
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.ASSIGN_OWNER}`, data, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // TICKET_AUTO_ASSIGN

  async callInternalTikcetAssignAsync(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.TICKET_AUTO_ASSIGN}`,
          data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET_MEMBERSHIP_OFFER
  async getMembershipOfferFromProfileID(profileID, id,IsIOSOffer) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MEMBERSHIP_OFFER}/${profileID}/${id}?IsIOSOffer=${IsIOSOffer}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // SET_MEMBERSHIP

  async setMembershipOffer(data, flag, id) {
    this.setToken();
    console.log(data);
    data.flagID = flag;
    console.log(data);

    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SET_MEMBERSHIP}`,
          data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  getProfileData(type, firstPage, lastPage) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.DASHBOARD_PROFILE}/${type}/${firstPage}/${lastPage}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
    // const promise = new Promise((resolve, reject) => {
    //   this.http
    //     .get(
    //       `${this.ROOT_URL}${this._urls.DASHBOARD_PROFILE}/${type}/${firstPage}/${lastPage}`,
    //       this._header
    //     )
    //     .toPromise()
    //     .then((res) => {
    //       // Success
    //       resolve(res);
    //     })
    //     .catch((err) => {
    //       reject(err);
    //     });
    // });
    // return promise;
  }

  getEmpProfiles(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EMPLOYEE_PROFILES}`, data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // GET INBOX_PROFILE DATA

  getInboxProfileData(side, type, constant, firstPage, lastPage) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_INBOX_PROFILE_ASYNC}?TypeOfData=${side}&TypeOfReport=${type}&OppFilter=${constant}&PageFrom=${firstPage}&PageTo=${lastPage}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  //Get EMployee list Based on Type
  getEmpListBasedOnGrade(side, type, constant, firstPage, lastPage) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_INBOX_PROFILE_ASYNC}?TypeOfData=${side}&TypeOfReport=${type}&OppFilter=${constant}&PageFrom=${firstPage}&PageTo=${lastPage}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET supmmery cards

  getSummeryCardAsync() {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_SUMMERY_CARD}`,
          '',
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // Get Other Side Inbox Prodfiles

  getOtherSideInboxProfileData(
    side,
    type,
    constant,
    firstPage,
    lastPage,
    filter
  ) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_INBOX_PROFILE_ASYNC}?TypeOfData=${side}&OppFilter=${filter}&PageFrom=${firstPage}&PageTo=${lastPage}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
    // const promise = new Promise((resolve, reject) => {
    //   this.http
    //     .get(
    //       `${this.ROOT_URL}${this._urls.DASHBOARD_PROFILE}/${type}/${firstPage}/${lastPage}`,
    //       this._header
    //     )
    //     .toPromise()
    //     .then((res) => {
    //       // Success
    //       resolve(res);
    //     })
    //     .catch((err) => {
    //       reject(err);
    //     });
    // });
    // return promise;
  }

  // GET_USER_PROFILE_DETAILS
  getUserProfileDetails(custId) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROFILE_DETAILS}?ToCustID=${custId}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_MESSAGE_HISTORY
  getUserMessageHistory(msgID, startIndex, EndIndex) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_MESSAGE_HISTORY}?MessageLinkId=${msgID}&StartIndex=${startIndex}&EndIndex=${EndIndex}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Message service
  getMessageDetailsAsync(status, pageFrom, pageTo) {
    this.setToken();
    status === null ? (status = '') : (status = status);
    const promise = new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SIDE_MESSAGE}?Status=${status}&PageFrom=${pageFrom}&PageTo=${pageTo}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // COMMON VIEW CLICK CALL ASYNC

  viewProfileCommonAsync(data) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.COMMON_ACTION_ON_PROFILE_VIEW}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Set user profile shortlisted
  setUserProfileShortlistedAsync(data) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SET_USER_SHORTLISTED}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Show not insterest
  showNegetiveInterest(data) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.COMMON_ACTION_ON_PROFILE_VIEW}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // get logged in user details
  getLoginUserProfileDetails() {
    this.setToken();
    const promise = new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.GET_USER_PROFILE}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // SEND_MESSAGE_TO_USER
  sendMessageToUserOpp(data) {
    this.setToken();
    // console.log(custID);
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_MESSAGE_TO_USER}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET USER RM DETAILS

  getUserRMDetails(custID) {
    this.setToken();
    // console.log(custID);
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_USER_RM}?CustID=${custID}`,
          { CustID: custID },
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  getUserRMDetailsNoCust() {
    this.setToken();
    // console.log(custID);
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.GET_USER_RM}`, null, this._header)
        .toPromise()
        .then((res) => {
          // Success

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // check mobile and email ID existance
  async checkMobileAndEmail(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHECK_EMAIL_MOBILE_EXIST}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Astro
  async getHoroscope() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_ASTRO_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // get success stories

  async getSuccessStories() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.SUCCESS_STORY}/1/10`)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Photo Management
  async getUserPhoto() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.GET_USERPHOTO}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // get others photo
  async getOtherUserPhoto(custID) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USERPHOTO}?CustID=${custID}&Flage=1`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }


  async getOtherUserPhotoSearch(custID) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.OTHER_PROFILE_PHOTO_SEARCH}?CustID=${custID}&Flage=${1}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // SET profile pic

  async setUserProfilePic(photoCustID) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SET_USER_PROFILE_PIC}/${photoCustID}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Delete Profile PIC
  async deleteProfilePic(data) {
    this.setToken();
    console.log(data);
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.DELETE_PROFILE_PIC}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  async loadMasterData(data) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MASTER_DATA}/?MasterName=${data}`
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  async loadMasterDataWithId(data, id) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MASTER_DATA}/?MasterName=${data}&MasterDependencyID=${id}`
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async createEmployeeIDByBranch(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.CREATE_EMP_ID}/${data}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }


  async countryCodeData(data) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_COUNTRY_CODE}/?MasterName=${data}`
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async countryMasterData(data) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_COUNTRY_CODE}/?MasterName=${data}`
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async registerUser(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.REGISTER_USER}`, data, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Registration page
  // Check verificationof mobile OTP
  async verifyMobileOTP(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.VERIFY_MOBILE_OTP}/${data}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // CHANGE_USER_PROFILE_ACCOUNT
  async changeUserEMAILandMobile(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHANGE_USER_PROFILE_ACCOUNT}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // change user pasword
  async changeUserPasswordAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHANGE_USER_PASSWORD}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  //Employee Notifications

  async getEmployeeNotifications(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EMPLOYEE_NOTIFICATIONS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // Verify Email
  async verifyEmailID(data) {
    // this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.VERIFY_EMAIL}/${data}`)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // CHANGE_PRIMARY_CONTACT
  async changeUserPrimaryDetailsAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHANGE_PRIMARY_CONTACT}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Verify Primary Contact Details

  async verifyUserPrimaryDetailsAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.VERIFY_CHANGE_CONTACT}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET USER TYPE DETAILS

  async getUserType() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.GET_USER_TYPE}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // resend mobile OTP code
  async resendMobileOTP(custId, typeID?) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.RESEND_MOBILE_OTP}/${custId}/${typeID}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          //console.log(res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Email Verification code
  async resendEmailVerificationCode() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.RESEND_EMAIL_VERIFICATION}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Edit Email
  async editEmailAddress(email) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.EDIT_EMAIL}/${email}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // edit Mobile number
  async editMobileNumber(countryCode, mobileNumber) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_MOBILE}/${countryCode}/${mobileNumber}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async saveOthersDetails(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_OTHER_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async saveEducationDetails(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDUCATION_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async saveFamilyDetails(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_FAMILY_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async saveAstroDetails(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_ASTRO_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async checkRegistrationStatus(stageId) {
    this.setToken();
    const data = '';
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHECK_REGISTRATION_STEP}?StageID=${stageId}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async checkRegistrationStatuswithToken(token) {
    this.setToken();
    this._commonHeader = 'bearer ' + token;
    this._herderOption = new HttpHeaders({
      Authorization: this._commonHeader,
    });

    const data = '';
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHECK_REGISTRATION_STEP}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async uploadProfilePhoto(uploadFileArray: any, custID) {
    this.setToken();
    const formData = await new FormData();
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('Files', _f);
      formData.append('DisplayOrder', '0');
    });
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_PROFILE_PHOTO}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }


  async uploadProfilePhotoAfterLogin(uploadFileArray: any, displayOrder, custID?: any) {
    this.setToken();
    const formData = await new FormData();
    const photoOrder = displayOrder === 0 ? 0 : displayOrder
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('Files', _f);
      formData.append('DisplayOrder', photoOrder);
      formData.append('CustID', custID);
    });
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_PROFILE_PHOTO}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_BASIC_DETAILS: '/api/Profile/UserBasicDetailsAsync',
  async getUserBasicDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_BASIC_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_FAMILY_DETAILS: '/api/Profile/UserFamilyDetailsAsync',
  async getUserFamilyDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_FAMILY_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_PROFESSION_DETAILS: '/api/Profile/UserProfessionDetailsAsync',
  async getUserProfessionDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROFESSION_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_EDUCATION_DETAILS: '/api/Profile/UserEducationDetailsAsync',
  async getUserEducationDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_EDUCATION_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_LOCATION_DETAILS: '/api/Profile/UserLocationDetailsAsync',
  async getUserLocationDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_LOCATION_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_CONTACT_DETAILS: '/api/Profile/UserContactDetailsAsync',
  async getUserContactDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_CONTACT_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_PARTNER_PRE_DETAILS:
  //   '​/api​/Profile​/PartnerPreferenceDetailsAsync',
  async getUserPartnerPrefDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PARTNER_PRE_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_PROPERTY_DETAILS: '/api/Profile/UserPropertyDetailsAsync',
  async getUserPropertyDetails() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROPERTY_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // ASTRO_DETAILS_GET
  async getUserAstroDetailsAsync() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.ASTRO_DETAILS_GET}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // USER_PAYMENT_SEND
  async userPaymentResponseAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.USER_PAYMENT_SEND}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GENERATE_ASTRO_USER
  async generateUserAstro() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GENERATE_USER_HOROSCOPE}`,
          '',
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // SAVE_USER ASTRO
  async saveUserAstroDetails(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_USER_ASTRO_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // UPLOAD_ASTRO_USER
  async uploadUserAstro(uploadFileArray, custID) {
    this.setToken();
    const formData = await new FormData();
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('HoroImage', _f);
      formData.append('custID', custID);
    });
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_USER_HOROSCOPE}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_PARTNER_PREFERENCE
  async getUserPartnerPereference() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PARTNER_PREFERENCE}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  async saveUserPartnerPreferenceAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_USER_PARTNER_PREFERENCE_EMP}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async getSuitableProfilesAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_PARTNER_SUITABLE_PROFILES}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async saveAutoMailProfilePriorityAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_AUTO_MAIL_PROFILE_PRIORITY}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Get user user Profession Details
  async getUserProfessionDetailsAsync() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROFILE_PROFESSION_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Get user family details
  async getUserFamilyDetailsAsync() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROFILE_FAMILY_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Family save
  async saveUserFamilyPreferenceAsync(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_FAMILY_PROFILE_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // GET_USER_MEMBERSHIP_DETAILS
  async getUserMembershipDetailsAsync() {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_MEMBERSHIP_DETAILS}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // Forgot password NEW_PASSWORD_SAVE
  async saveNewPasswordAsync(data) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.NEW_PASSWORD_SAVE}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // /api/Search/UserDefaultSearchInformationAsync?empID=176410

  async searchDefaultValue(custID, savedSearchId) {
    this.setToken();
    // alert(savedSearchId);
    const url =
      savedSearchId === null
        ? `${this.ROOT_URL}${this._urls.GET_DEFAULT_SEARCH}`
        : `${this.ROOT_URL}${this._urls.GET_DEFAULT_SEARCH}?savedSearchId=${savedSearchId}`;

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(`${url}`, null, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // SEARCH_WITH_PARAMETER

  async searchWithParameter(profileId, name, startIndex, endIndex) {
    this.setToken();
    let url =
      profileId !== null
        ? `${this.ROOT_URL}${this._urls.SEARCH_WITH_PARAMETER}?ProfileID=${profileId}`
        : `${this.ROOT_URL}${this._urls.SEARCH_WITH_PARAMETER}?LastName=${name}&StartIndexID=${startIndex}&EndIndexID=${endIndex}`;
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(url, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async savedSearchValue(custID, savedSearchId) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.USER_SAVED_SEARCH}`,
          null,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // Delete the search
  async savedSearchDeleteAsync(savedSearchId, booleanVal) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.USER_SAVED_SEARCH}?savedSearchId=${savedSearchId}&isDelete=${booleanVal}`,
          null,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // SEARCH_USER_WITH_ARRAY

  async searchUserWithArrayAsync(searchData, startIndex, endIndex) {
    this.setToken();
    searchData.startIndexID = startIndex;
    searchData.endIndexID = endIndex;
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEARCH_USER_WITH_ARRAY}`,
          searchData,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  //USER_SEND_INTREST
  async sendUserInterest(data) {
    this.setToken();

    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.USER_SEND_INTREST}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // payment
  getUserProfileDetailsWithPaymentOption(custId) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_PROFILE_DETAILS}?ToCustID=${custId}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // EXPRESS_INTRESET_SKIP_PROCEED{}
  async userExpressInterest(custId, logID, interestType) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EXPRESS_INTRESET_SKIP_PROCEED}?ToCustID=${custId}&LogID=${logID}&InterstType=${interestType}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_USER_CONTACT
  async getRegularUserContactDetails(data) {
    this.setToken();

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_USER_CONTACT}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // EDIT_WITH_SECTION
  async editWithSection(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.EDIT_WITH_SECTION}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // GET_PAYMENT
  paymentStatics() {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.ROOT_URL}${this._urls.GET_PAYMENT}`, '', this._header)
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // home
  async changeUserType(profileID, userType) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.CHANGE_USER_TYPE}?profileID=${profileID}&serviceType=${userType}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getRegisteredValidatedUsers(profileValidationForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.REGISTRATION_PROFILE_VALIDATED}`,
          profileValidationForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getRegisteredValidatedUsersCount(profileValidationForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.REGISTRATION_PROFILE_VALIDATED_COUNT}`,
          profileValidationForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async viewProfile(profileId, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EMP_VIEW_PROFILE}?ProfileID=${profileId}&EmpID=${empId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async viewProfileByFormat(profileId, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USER_DETAILS_BY_FORMAT}?ProfileID=${profileId}&ViewFormat=${empId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async viewMatchFollowupProfile(fromCustId, toCustId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EMP_VIEW_MATCHFOLLOWUP_PROFILE}/${fromCustId}/${toCustId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }




  async createGuestTicket(guestTicketForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GUEST_TICKET_CREATE}`,
          guestTicketForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getTicketInformation(ticketId, type) {
    console.log('Inservice')
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.TICKET_INFORMATION}/${ticketId}/${type}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getRelationData(flag, profileId, relationShipId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.TICKET_EXPRESS_RELATION_INFO}/${flag}/${profileId}/${relationShipId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getAssignReAssignData(flag, EmapName) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.TICKET_PROFILE_BINDINGS}/${EmapName}/${flag}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getReplyTypeData(flag, id, relationShipId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.TICKET_REPLYTYPE_DATA}/${flag}/${id}/${relationShipId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async saveIncomingCall(incomingCallForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.TICKET_SAVE_INCOMING_CALL}`,
          incomingCallForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveTicketInternalMemo(internalMemoForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.TICKET_SAVE_INTERNAL_MEMO}`,
          internalMemoForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveClosedTicket(closeTicketForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.TICKET_CLOSE}`,
          closeTicketForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async verifyMobileNumber(custId, typeId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SEND_VERIFICATION_CODE}/${custId}/${typeId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async verifyTicketMobileOTP(custId, otp) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.VERIFY_TICKET_OTP}/${custId}/${otp}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async verifyTicketEmail(custId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.VERIFY_TICKET_EMAIL}/${custId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async emailBounce(custId, IsEmailBounce) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.VERIFY_TICKET_EMAIL}/${custId}?IsEmailBounce=${IsEmailBounce}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async verifyEmailManually(verifyEmailManuallyObj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
           `${this.ROOT_URL}${this._urls.VERIFY_EMAIL_MANUALLY}`,
           verifyEmailManuallyObj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getTicketPhotos(custId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_TICKET_PHOTOS}/${custId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async submitRemainder(remainderForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.REMAINDER_FORM}`,
          remainderForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //Payment Details Services

  async getPaymentDetails(pId, profileHistoryId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_PAYMENT_DETAILS}/${pId}/${profileHistoryId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveEditSA(saForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_SA_AMOUNT}`,
          saForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async viewContactOrEmailForOtherEmp(obj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.VIEW_CONTACT_EMAIL_OTHER_EMPLOYEES}`,
          obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async viewOtherContactAccess(obj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CHECK_OTHER_CONTACT_ACCESS}`,
          obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async savePaymentDetails(paymentObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PAYMENT_DETAILS_WITH_OFFERS}`,
          paymentObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async paymentExtensionPointDays(profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_POINT_DAYS}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getMasterData() {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_BASIC_MASTER_DATA}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getMarketingSlideData(marketingObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.MARKETING_VIEW_HISTORY}`,
          marketingObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getResponseTypeData() {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MASTER_DATA_RESPONSE_TYPE}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async sendSMSToCustomer(smsObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_SMS_TO_SLIDE_TICKET}`,
          smsObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendEmailToCustomer(emailObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_EMAIL_TO_SLIDE_TICKET}`,
          emailObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendFullProfile(fullProfileObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_FULL_PROFILE}`,
          fullProfileObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));

  }
  async getSetDelDetails(custId, type) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_SET_DEL_DETAILS}/${custId}/${type}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateSiblingDetails(siblingObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_SIBLING_DATA}`,
          siblingObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getMatchFollowupCount(empID, isDashboard) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.MATCH_COUNT}/${empID}/${isDashboard}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // MATCH_RESEND

  async getMtachResendAsync(empID, pageFrom, pageTo, type) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.MATCH_RESEND}/${empID}/${pageFrom}/${pageTo}/${type}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getProfileInfo(profileId) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_ADMIN_PROFILE_INFO}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getDuplicateAssignedProfiles(profileId) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_ASSIGNED_DUPLICATE_PROFILE}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveAdminEditForm(adminForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PAYMENT_ADIMIN_FORM}`,
          adminForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getGuestTicketAsync(profileForm) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_GUEST_TICKET_ASYNC}`,
          profileForm,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async checkGuestTicketWithProfile(profileId) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_TICKET_PROFILE_EXISTS}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET_MATCH_TICKET_HOSTORY
  async getMatchTicketHistory(ticketId, type) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MATCH_TICKET_HOSTORY}/${ticketId}/${type}`, this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getMatchFollowMatchUpPost(data) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_MATCH_FOLLOW_UP}`,
          data, this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET_OTHER_MATCH_FOLLOW_UP
  async getOtherMatchFollowUpAsync(data) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_OTHER_MATCH_FOLLOW_UP}`,
          data, this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getStaffNamesAsync(fromID) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_STAFF_NAMES}?fromEmpid=${fromID}`, this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET_STAFF_DATA{


  async getStaffDataAsync(fromID, toID, pageFrom, pageTo) {
    this.setToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_STAFF_DATA}/${fromID}/${toID}/${pageFrom}/${pageTo}`, this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET_MATCH_TICKET_HOSTORY


  async insertPofileTicket(formValues) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.INSERT_GUEST_TICKET}`,
          formValues,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveMatchFollowUpRemainder(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.INSERT_MFP_REMAINDER}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendWakenUpToOtherEmp(wakeObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_WAKEUP_MESSAGE}`,
          wakeObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async submitSMS(smsObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_SMS}`,
          smsObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getBrideAndGroomData(profileId, flag) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_BRIDE_GROOM_DATA}/${profileId}/${flag}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveMatchMeetingEntryForm(formData) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_MATCH_MEETING_ENTRY_FORM}`,
          formData,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async activeProfiles(brideProfileId, groomProfileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.ACTIVE_PROFILES}/${brideProfileId}/${groomProfileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async matchFollowUpTicketStatus(ticketId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MATCH_TICKET_STATUS}/${ticketId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveMatchFollowupIncoming(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_MATCH_FOLLOWUP}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async callCommunicationLog(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.INSERT_INCOMING_COMMUNICATION}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendEmailFromTicket(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_EMAIL_TICKET}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async savePaymentPoints(pointsObject) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_POINTS_DATA}`,
          pointsObject,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  //KEYWORD_SEARCH

  async keyWordSearch(searchFormValues) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.KEY_WORD_SEARCH}`,
          searchFormValues,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // ADVANCED_SEARCH
  async advancedSearchASync(searchFormValues) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.ADVANCED_SEARCH}`,
          searchFormValues,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async Proceed(value) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.PROCEED}`,
          value,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async dontProceed(value) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.PROCEED}`,
          value,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async generalSearchASync(searchFormValues) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GENERAL_SEARCH}`,
          searchFormValues,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
//
async setShortlistProfile(object) {
  this.setToken();
  return new Promise((resolve, reject) => {
    this.http
      .post(
        `${this.ROOT_URL}${this._urls.SET_SHORTLIST_PROFILE}`,
        object,
        this._header
      )
      .toPromise()
      .then((response) => {
        // //console.log(response);
        resolve(response);
      });
  }).catch((err) => console.error(err));
}


  //Edit/View
  async searchEditProfileView(searchFormValues) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEARCH_EDIT_VIEW}`,
          searchFormValues,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async viewCustomerSettleDeleteInfo(custId, type) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SETTLE_DELETE_INFO_ASYNC}/${custId}/${type}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getMMSeriousData(profileId, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.MMSERIOUS_ASYNC}/${profileId}/${empId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getOwnerDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_OWNER_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async viewSaForm(profileID) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SA_FORM_VIEW}/${profileID}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getProfileDetails(profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.PLAY_BUTTON_PROFILE_DETAILS}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async playSlideShowMode(formValue) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.PLAY_SLIDE_SHOW}`,
          formValue,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async playSlideShowModeForProfileValidation(formValue) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.PLAY_SLIDE_SHOW_PROFILE_VALIDATION}`,
          formValue,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async uploadSAPhoto(uploadFileArray: any, profileId: any) {
    this.setToken();
    // console.log(uploadFileArray);
    const formData = await new FormData();
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('Files', _f);
      formData.append('profileID', profileId);
      formData.append('SettlementAgreedAmount', '0');
      formData.append('Notes', '');
      formData.append('isActive', '0');
      formData.append('isassigned', '0');
      formData.append('ReferenceID', '0');

      // console.log(_f, index);
    });

    // console.log(uploadFileArray);

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_SA_PHOTO}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  async uploadSettlementPhoto(uploadFileArray: any, profileId: any,empID:any,Notes:any,isassigned:any,referenceId:any ) {
    this.setToken();
    // console.log(uploadFileArray);
    const formData = await new FormData();
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('Files', _f);
      formData.append('profileID', profileId); 
      formData.append('empID', empID);
      formData.append('Notes', Notes);
      formData.append('isActive', '0');
      formData.append('isassigned', isassigned);
      formData.append('ReferenceID', referenceId);

      // console.log(_f, index);
    });

    // console.log(uploadFileArray);

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_SA_PHOTO}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async deleteSaPhoto(settleID) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SA_FORM_DELETE}`,
          settleID,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async uploadEmployeePhoto(uploadFileArray: any, loginID: any) {
    this.setToken();
    // console.log(uploadFileArray);
    const formData = await new FormData();
    uploadFileArray.map((_f, index) => {
      delete _f.url;
      formData.append('Files', _f);
      formData.append('LoginName', loginID);
      // formData.append('SettlementAgreedAmount', '0');
      // formData.append('Notes', '');
      // formData.append('isActive', '0');
      // formData.append('isassigned', '0');
      // formData.append('ReferenceID', '0');

      // console.log(_f, index);
    });

    // console.log(uploadFileArray);

    const promise = new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPLOAD_EMPLOYEE_PHOTO}`,
          formData,
          this._imageHeader
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async editViewPhotoRequest(id, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_PHOTO_REQUEST}?profileID=${id}&empID=${empId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async preloadSearch(id, empId, type) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.PRELOAD_SEARCH}/${id}/${empId}/${type}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async editViewForgotPassword(profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_FORGOT_PASSWORD}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getServiceInfo(fromProfileId, toProfileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_SERVICE_PROFILE_INFO}/${fromProfileId}/${toProfileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveExpressInfo(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EXPRESS_INTEREST}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getServiceCount(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_SERVICE_COUNT}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getExpressInterestImages(profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EXPRESS_IMAGES}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendForgotPasswordEditView(profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SEND_EDIT_VIEW_FORGOT_PASSWORD}/${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getCommunicationLogValues(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_COMMUNICATION_LOG}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendEmailForCommunicationLog(custId, email) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_EMAIL_COMMUNICATIONLOG}`,
          { email: email, custID: custId },
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async resendCommunicationEmail(emailObj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_RESEND_COMMUNICATIONLOG}`,
          emailObj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  // Service slide show
  async getServiceSlideData(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_SERVICE_SLIDESHOW_DATA}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  //Edit/View Dashboard services

  async getEditViewCustomerrEducationDetails(custId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_EDUCATIONAL_DETAILS}/${custId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getCustomerPersonalDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_PERSONAL_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getEditViewCustomerrEducationAboutYourself(id, flag, yourself) {
    const obj = {
      "flag": flag,
      "custID": id,
      "aboutYourself": yourself
    }
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_EDUCATION_ABOUT}`, obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }



  //-----------Click To Call------
  async getCustomerContactID(RelationID,custID,typeID) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_CUSTOMER_CONTACT_ID}?RelationID=${RelationID}&custID=${custID}&ContactType=${typeID}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getCustomerCallLogs(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_CALL_LOGS}?Flag=${data.flag}&CustID=${data.custID}&StartIndex=${data.startIndex}&EndIndex=${data.endIndex}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async getEmployeeCallReports(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EMP_CALL_REPORTS}?FromCallDate=${data?.fromDate}&ToCallDate=${data?.toDate}&ProfileID=${data?.profileID}&PageID=${data?.pageId}&RegionID=${data?.regionId}&BranchID=${data?.branchId}&EmpID=${data?.empId}&StartIndex=${data?.startIndex}&EndIndex=${data?.endIndex}&CallStatus=${data?.CallStatus}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async initiateClickToCall(obj) {    
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.INITIATE_CLICK_TO_CALL}`, obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async sendBankDetails(obj) {    
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_BANK_DETAILS}`, obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getEditViewDashBoardProfileDetails(flag, custId) {

    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_DASHBOARD_PROFILE_DETAILS}?flag=${flag}&Id=${custId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getEditViewCustomerNoDataInfo(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_NO_DATA_INFO}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getProfessionalDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_PROFESSIONAL_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getGoalsInterestsDetails(id, yourself, flag) {
    const obj = {
      "flag": flag,
      "custID": id,
      "aboutYourself": yourself
    }
    
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_GOALS_INTERESTS_DETAILS}`, obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async updateEditViewPersonalDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_UPDATE_EDIT_VIEW_PERSONAL_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateEditViewEDUDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_UPDATE_EDIT_VIEW_EDU_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateEditViewProfessionalDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SEND_UPDATE_EDIT_VIEW_PROFESSIONAL_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async deletedEditViewObject(custId, eduId, type) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.DELETE_EDIT_VIEW_OBJ}/${type}/${custId}/${eduId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async isMeritSelectedService(obj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_MERIT_SELECTED}`,
          obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  // CHECKDOBNAME
  async checkDobName(name, surname, dob) {
    this.setToken();
    const data = {
      name: name,
      surName: surname,
      dob: dob
    }
    let url = `${this.ROOT_URL}${this._urls.CHECKDOBNAME}`
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${url}`, data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // CHECK_EMAIL_MOBILE
  async checkEmail(email) {
    this.setToken();
    let url = email ? `${this.ROOT_URL}${this._urls.CHECK_EMAIL_MOBILE}/?EmailMobile=${email}&FlagEmailmobile=0` : '';
  
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${url}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async checkMobile(mobile) {
    this.setToken();
    let url =  mobile ? `${this.ROOT_URL}${this._urls.CHECK_EMAIL_MOBILE}?EmailMobile=${mobile}&FlagEmailmobile=1` : '';
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${url}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // CUSTOMER_REGISTRATION_ONE
  async customerRegistrationStepOne(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CUSTOMER_REGISTRATION_ONE}`,
          data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // CUSTOMER_FULL_STEP_REG
  async customerRegistrationStepTwo(data) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.CUSTOMER_FULL_STEP_REG}`,
          data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }




  //EDIT VIEW Parent Details

  async getParentDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_PARENT_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateEditViewParentDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_PARENT_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveEditViewContactForm(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_PARENT_CONTACT_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  
  async saveEditViewContactDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_CONTACT_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async saveReferenceDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_REFERENCE_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async saveRelationName(custID,mobileRel,emailRel,iFlag) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_RELATION_NAME_DETAILS}?custID=${custID}&primaryMobileRel=${mobileRel}&primaryEmailRel=${emailRel}&iflag=${iFlag}`, this._header)
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async saveEditViewHealthForm(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_PARENT_HEALTH_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveABTFAMILY(id, yourself, flag) {
    const data = {
      custID: id,
      aboutYourself: yourself,
      flag: flag
    }
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_ABT_FAMILY}`, data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));

  }

  //Edit View Partner Preferences
  async getPartnerPrefernces(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_PARTNER_PREFERENCES}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateEditPartnerDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_VIEW_PARTNER_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveEditViewCandiate(id, object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_CADITATE_DESCRIPTION}/${id}/${object}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveEditViewPartnerDec(id, object, flag) {
    const data = {
      custID: id,
      aboutYourself: object,
      flag: flag
    }
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PARTNER_DESCRIPTION}`, data,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //Payment Authorization 

  async getPaymentAuthData(branchId, startDate, region, endDate, profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_PAYMENT_AUTH_DATA}?BranchID=${branchId}&StartDate=${startDate}&EndDate=${endDate}&Region=${region}&ProfileID=${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async savePaymentAuthorization(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PAYMENT_AUTHORIZATION}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveTicket(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_TICKET}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //Aestro Details

  async getAestroDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_GET_AESTRO}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async generateHoroService(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GENERATE_HOROSCOPE}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  //Edit View Property Details

  async getPropetyDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_GET_PROPERTY}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updatePropertyDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PROPERTY_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //Edit View Relative Details 

  async getRelativeDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_GET_RELATIVE_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateFatherBrotherPropertyDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_FATHER_BROTHER_PROPERTY}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateFatherSisterPropertyDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_FATHER_SISTER_PROPERTY}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateMotherBrotherPropertyDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_MOTHER_BROTHER_PROPERTY}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateMotherSisterPropertyDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_MOTHER_SISTER_PROPERTY}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async deleteRelativeObject(type, custId, identifiedId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.DELETE_EDIT_VIEW_RELATIVE_OBJ}/${type}/${custId}/${identifiedId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //References 

  async getReferenceDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_EDIT_GET_REFERENCE_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async updateReferenceDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_REFERENCE_DETAILS}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //office purpose
  async getOfficeRefDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_OFFICE_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getEditViewOfficeAboutDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_OFFICE_ABOUT_PROFILE}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async dontShowProfilesService(custId, toProfileId, empId, relationId, flag) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_DONT_SHOW_PROFILE}/${custId}/${toProfileId}/${empId}/${relationId}/${flag}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async attendedCustomerDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_OFFICE_ATTEND_CUSTOMER}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

    async showAttendedCustDetails(custID){
      this.setToken();
      return new Promise((resolve, reject) => {
        this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_VIEW_OFFICE_SHOW_ATTENDED_CUSTOMERS.replace('{custID}', custID)}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
      })
    }

  //matchMeeting Entry

  async verifyBrideAndGroomStatus(brideId, groomId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.MATCH_MEETING_BRIDE_GROOM_ASYNC}/${brideId}/${groomId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  //ProfileSettings

  async getProfileSettingDetails(id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_PROFILE_SETTING_DETAILS}/${id}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveProfileSettingObject(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PROFILE_SETTINGS_OBJECT}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveTempProfileSettingObject(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_TEMP_PROFILE_SETTINGS_OBJECT}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveConfidentialDetails(isConfidential, veryHighConfidential,exclusiveGrade, confidentialGrade, aboutProfile, flag, id) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_EDIT_VIEW_DASHBOARD_PROFILE_DETAILS}?AboutProfile=${aboutProfile}&HighConfendential=${veryHighConfidential}&ID=${id}&IsConfidential=${isConfidential}&flag=${flag}&ConfidentialGrade=${confidentialGrade}&SuperHighConfidential=${exclusiveGrade}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getPartnerPreferenceCount(custID) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_PARTNER_PREFERENCE_COUNT}/${custID}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveGradeDetails(object) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.SAVE_PROFILE_GRADES}`,
          object,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async saveCustomerLogin(value, id, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SAVE_CUSTOMER_LOGIN}/${empId}/${id}/${value}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getPersonalVisit(profileId, id, highConfidential, confidential, flag) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SEARCH_PERSONAL_OFFICE}?AboutProfile=${id}&HighConfendential=${highConfidential}&ID=${profileId}&IsConfidential=${confidential}&flag=${flag}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async getPrimaryCustomerAsync(relationId, empId, profileId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SEARCH_GET_PRIMARY_CUSTOMER}?Relationship=${relationId}&empid=${empId}&profileID=${profileId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  async deleteHoroscopeImage(obj) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.DELETE_HORO_IMG}`,
          obj,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }
  // GET GET_SIBLING_DETAILS
  async getSiblingDetails(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_SIBLING_DETAILS}/${data}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // UPDATE_SIBLING_COUNT?
  async updateSiblingCount(data) {
    this.setToken();
    console.log(data);
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_SIBLING_COUNT}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // UPDATE_SIBLING_BROTHER
  async updateSiblingBrother(data) {
    this.setToken();
    console.log(data);
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_SIBLING_BROTHER}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  // /api/Siblings/UpdateCustomerSiblingsDetailsSisterAsync

  async updateSiblingSister(data) {
    this.setToken();
    console.log(data);
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_SIBLING_SISTER}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }


  // GET_SPOUSE_DETAILS
  async getSpouseDetails(data) {
    this.setToken();
    console.log(data);
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_SPOUSE_DETAILS}/${data}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // UPDATE_SPOUSE_DETAILS
  async updateSpouseDetails(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.UPDATE_SPOUSE_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // ADD_CHILDREN_DETAILS
  async updateChildDetails(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.ADD_CHILDREN_DETAILS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  // CONTACT_GET
  async getContacts(data,isMarketing) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.CONTACT_GET}/${data}/${isMarketing}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  //GET EMPLOYEE LIST BASED ON ACCESS

  async getEmployeeListBasedOnAccess(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EMPLOYEE_ACCESS}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }


  async requestEditViewPhoto(id, empId) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.EDIT_SAVE_PHOTO_REQ}?profileID=${id}&empID=${empId}`,
          this._header
        )
        .toPromise()
        .then((response) => {
          // //console.log(response);
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }


  async getEditViewPhoto(custID, flag) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_USERPHOTO}?CustID=${custID}&Flage=${flag}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async getPersoanalDataAsync(id) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.PERSONAL_DATA_ASYNC}/${id}`,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async openMatchFollowTicket(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.OPEN_MATCH_FOLLOW_TKT_ASYNC}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async ticketCreationMatchFollowup(data){
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.TICKET_CREATION_MATCH_FOLLOWUP}`,
          data,
          this._header
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async getPhotosInEditView(id) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(`${this.ROOT_URL}${this._urls.GET_USERPHOTO}?CustID=${id}&Flage=2`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }
  async setProfilephotoPassword(CustPhotoID, Flag){
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.SET_PASSWORD_IMAGE}/${CustPhotoID}/${Flag}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async getServiceSlideShowAsync(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.SERVICE_SLIDE_SHOW_ASYNC}`, data, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getPagePermissionsData(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.PERMISSION_PAGE_ASYNC}/${data}`, this._header)
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async updatePermissionData(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_PERMISSION_PAGE_ASYNC}`, data, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getUserBranchDetails(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.get(`${this.ROOT_URL}${this._urls.GET_USER_BRANCH_DETAILS}/${data}`, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getBranchIPDetails(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.GET_BRANCH_IP_DETAILS}`, data, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async updateBranchIP(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_BRANCH_IP}`, data, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async updateUserBranchIP(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_USER_BRANCH_IP}`, data, this._header).toPromise().then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async createBroker(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.REGISTER_BROKER_ASYNC}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getBrokerCommissionList() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.get(`${this.ROOT_URL}${this._urls.GET_BROKER_COMMISSION_ASYNC}`, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getAllBrokers() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.get(`${this.ROOT_URL}${this._urls.GET_ALL_BROKER_DETAILS}`, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async updateBroker(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_BROKER_DETAILS}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async deleteBroker(id) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.get(`${this.ROOT_URL}${this._urls.DELETE_BROKER_DETAILS}/${id}`, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getAvailableCustomersIndia(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.AVAILABLE_CUSTOMERS_INDIA}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getCustomersInLastWeek() {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.get(`${this.ROOT_URL}${this._urls.GET_CUSTOMERS_LEFT_PAST_WEEK}`, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async updateDepartedCustomerInfo(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_DEPARTED_CUSTOMER_INFO}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async brokerUpdatePhotoORFile(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_BROKER_PHOTO_OR_FILE}`, data, this._imageHeader).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async deleteBrokerPhotoORFile(data){
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.DELETE_BROKER_PHOTO_OR_FILE}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async getMyProfiles(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.MY_ACCOUNT_API}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }
  async getAllEmployeeList(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.EMPLOYEE_DETAILS_PAGE_ASYNC}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }
  async createEmployees(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.EMPLOYEE_CREATE}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async updateEmpViewFormatAsync(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.UPDATE_EMP_VIEW_FORMAT}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  async loadSearchMasterData(data, val, groupID?) {
    const promise = await new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.ROOT_URL}${this._urls.GET_MASTER_SEARCH_DATA_ASYNC}/?MasterName=${data}&MasterValue=${val}&GroupId=${groupID == undefined ? '' : groupID}`
        )
        .toPromise()
        .then((res) => {
          // Success
          resolve(res); // resolving the response data
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  async getActivityTracking(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.GET_ACTIVITY_TRACKING}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }
// R E P O R T S

  async getUTMReport(data) {
    this.setToken();
    const promise = await new Promise((resolve, reject) => {
      this.http.post(`${this.ROOT_URL}${this._urls.  GET_UTM_REPORTS}`, data, this._header).toPromise().then((res) =>{
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
    return promise;
  }

  
  async failedRegistrationReport(getFailedRegistrationDetails) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_FAILEDREG_REPORTS}`,
          getFailedRegistrationDetails,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async empReportData(getEmployeeReportDetails) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EMP_REPORT_DATA}`,
          getEmployeeReportDetails,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
  }

  async empTaskDetailsCount(getEmpTaskDetailsCount) {
    this.setToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.ROOT_URL}${this._urls.GET_EMP_DETAILS_COUNT}`,
          getEmpTaskDetailsCount,
          this._header
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        });
    }).catch((err) => console.error(err));
}

async getActivityPoints(val: number) {
  this.setToken();
  return new Promise((resolve, reject) => {
    this.http
      .get(
        `${this.ROOT_URL}${this._urls.GET_ACTIVITY_POINTS}/${val}`,
        this._header
      )
      .toPromise()
      .then((response) => {
        resolve(response);
      });
  }).catch((err) => console.error(err));
}

async updateActivityPoints(updateActivityPointsParams) {
  this.setToken();
  return new Promise((resolve, reject) => {
    this.http
      .post(
        `${this.ROOT_URL}${this._urls.UPDATE_ACTIVITY_POINTS}`,
        updateActivityPointsParams,
        this._header
      )
      .toPromise()
      .then((response) => {
        resolve(response);
      });
  }).catch((err) => console.error(err));
}

async tempDeleteProfilesReport(getTempDeleteProfilesDetails) {
  this.setToken();
  return new Promise((resolve, reject) => {
    this.http
      .post(
        `${this.ROOT_URL}${this._urls.GET_TEMP_DELETE_REPORT}`,
        getTempDeleteProfilesDetails,
        this._header
      )
      .toPromise()
      .then((response) => {
        resolve(response);
      });
  }).catch((err) => console.error(err));
}


async emailBounedProfilesReport(getEmailBouncedProfilesDetails) {
  this.setToken();
  return new Promise((resolve, reject) => {
    this.http
      .post(
        `${this.ROOT_URL}${this._urls.GET_EMAIL_BOUNCED_REPORT}`,
        getEmailBouncedProfilesDetails,
        this._header
      )
      .toPromise()
      .then((response) => {
        resolve(response);
      });
  }).catch((err) => console.error(err));
}

}
// GET_STAFF_NAMES

// payment

// this.service.getUserProfileDetails((res) => {
//   console.log(res);
//   if (res['statusCode'] === 200) {
//   } else {
//   }
// });
